export var BreadCrumbSelectMode;
(function (BreadCrumbSelectMode) {
    /** Default behaviour, clicking this will clear the values of all child params. */
    BreadCrumbSelectMode[BreadCrumbSelectMode["Default"] = 0] = "Default";
    /** Breadcrumb is not selectable. */
    BreadCrumbSelectMode[BreadCrumbSelectMode["None"] = 1] = "None";
    /** Clicking on the breadcrumb item will select the parent item. */
    BreadCrumbSelectMode[BreadCrumbSelectMode["SelectParent"] = 2] = "SelectParent";
})(BreadCrumbSelectMode || (BreadCrumbSelectMode = {}));
